import { render, staticRenderFns } from "./ArticlesInOrdered.vue?vue&type=template&id=dbf8adfc&scoped=true"
import script from "./ArticlesInOrdered.vue?vue&type=script&lang=js"
export * from "./ArticlesInOrdered.vue?vue&type=script&lang=js"
import style0 from "./ArticlesInOrdered.vue?vue&type=style&index=0&id=dbf8adfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf8adfc",
  null
  
)

export default component.exports